import { render, staticRenderFns } from "./ReplyMessagePreviewModal.vue?vue&type=template&id=928d9530"
import script from "./ReplyMessagePreviewModal.vue?vue&type=script&lang=js"
export * from "./ReplyMessagePreviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports